import { Link as LinkR } from 'react-router-dom'
import { Link as LinkS } from 'react-scroll'
import styled from 'styled-components'
import { colors } from '../../style'

export const Nav = styled.nav`
    background: ${({ scrollNav }) => (scrollNav ? colors.black : 'transparent')};
    height: 80px;
    margin-top: -80px; 
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    position: sticky;
    top: 0;
    z-index: 10;

    @media screen and (max-width: 960px) {
        transition: 0.8s all ease;
    }
`

export const NavbarContainer = styled.div`
    display: flex;
    justify-content: space-between;
    height: 80px;
    z-index: 1;
    width: 100%;
    padding: 0 24px;
    max-width: 1200px;
`

export const NavLogo = styled(LinkR)`
    color: ${colors.white};
    justify-self: flex-start;
    cursor: pointer;
    display: flex;
    font-size: 2rem;
    align-items: center;
    margin-left: 24px;
    font-weight: bold;
    text-decoration: none;
    font-family: 'Bangers';
`

export const LogoImg = styled.img`
    width: 2.5rem;
    margin: 0 0 4px 8px;
`

export const MobileIcon = styled.div`
    display: none;

    @media screen and (max-width: 768px) {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(-100%, 60%);
        font-size: 1.8rem ;
        cursor: pointer;
        color: ${colors.white};
    }
`

export const NavMenu = styled.ul`
    display: flex;
    align-items: center;
    justify-content: center;
    list-style: none;
    text-align: center;

    @media screen and (max-width: 768px) {
        display: none;
    }
`

export const NavItem = styled.li`
    min-width: 120px;
    height: 80px;
`

export const NavLink = styled(LinkS)`
    color: ${colors.white};
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    height: 100%;
    cursor: pointer;

    &.active {
       border-bottom: 3px solid ${colors.green};
    }
`

export const NavBtn = styled.nav`
    display: flex;
    align-items: center;

    @media screen and (max-width: 768px) {
        display: none;
    }
`

export const NavBntLink = styled(LinkR)`
    border-radius: 50px;
    background: ${colors.green};
    white-space: nowrap;
    padding: 10px 22px;
    color: ${colors.black};
    font-size: 16px;
    outline: none;
    border: none;
    cursor: pointer;
    text-decoration: none;

    &:hover {
        transition: all 0.2s ease-in-out;
        background: ${colors.white};
        color: ${colors.black};
    }
`